export const OPERATIONS_ROUTES = {
  index: {
    path: 'dashboard/*',
    to: '/dashboard',
  },
  manualOperations: {
    path: 'manual-station',
    to: '/dashboard/manual-station', //Temp
  },
  simulation: {
    path: 'simulation',
    to: '/dashboard/simulation',
  },
  flowHistory: {
    path: 'flowHistory',
    to: '/dashboard/flowHistory',
  },
  manualStation: {
    path: 'manual-station',
    to: '/dashboard/manual-station',
  },
  manualRun: {
    path: 'manual-run',
    to: '/dashboard/manual-run',
  },
  manualPrograms: {
    path: 'manual-programs',
    to: '/dashboard/manual-programs',
  },
  stations: {
    path: 'stations',
    to: '/dashboard/stations',
  },
  programs: {
    path: 'programs',
    to: '/dashboard/programs',
  },
  savedComparison: {
    path: 'saved-comparison',
    to: '/dashboard/saved-comparison',
  },
  dynamicDashboard: {
    path: 'dynamic-dashboard',
    to: '/dashboard/dynamic-dashboard',
    create: {
      path: 'dynamic-dashboard/create',
      to: '/dashboard/dynamic-dashboard/create',
    },
    view: {
      path: 'dynamic-dashboard/:id/view',
      to: '/dashboard/dynamic-dashboard/:id/view',
    },
    edit: {
      path: 'dynamic-dashboard/:id',
      to: '/dashboard/dynamic-dashboard/:id',
    },
  },
  irrigationOverview: {
    path: 'irrigation-overview',
    to: '/dashboard/irrigation-overview',
  },
  rainOperations: {
    path: 'rain-operations',
    to: '/dashboard/rain-operations',
  },
  programSchedule: {
    path: 'programSchedule',
    to: '/dashboard/programSchedule',
  },
  weather: {
    path: 'weather',
    to: '/dashboard/weather',
  },
  sensors: {
    path: 'sensors',
    to: '/dashboard/sensors',
  },
  zeusDashboard: {
    path: 'zeusDashboard',
    to: '/dashboard/zeusDashboard',
  },
  scadaDashboard: {
    path: 'scadaDashboard',
    to: '/dashboard/scadaDashboard',
  },
  flowSensors: {
    path: 'flowSensors',
    to: '/dashboard/flowSensors',
  },
  mapview: {
    path: 'mapview',
    to: '/dashboard/mapview',
  },
  fertigationDashboard: {
    path: 'fertigation-dashboard',
    to: '/dashboard/fertigation-dashboard',
  },
  filtration: {
    path: 'filtration',
    to: '/dashboard/filtration',
  },
  fertigation: {
    path: 'fertigation',
    to: '/dashboard/fertigation',
  },
  etAdjust: {
    path: 'et-adjust',
    to: '/dashboard/et-adjust',
  },
  dryRun: {
    path: 'dry-run',
    to: '/dashboard/dry-run',
  },
  mad: {
    path: 'mad',
    to: '/dashboard/mad',
  },
  alerts: {
    path: 'alerts',
    to: '/dashboard/alerts',
  },
  waterBudget: {
    path: 'water-budget',
    to: '/dashboard/water-budget',
  },
  runTime: {
    path: 'run-time',
    to: '/dashboard/run-time',
  },
  learnFlow: {
    path: 'learn-flow',
    to: '/dashboard/learn-flow',
  },
  diagnosis: {
    path: 'diagnosis',
    to: '/dashboard/diagnosis',
  },
  activities: {
    path: 'other/activities',
    to: '/dashboard/other/activities',
  },
  reports: {
    path: 'other/reports',
    to: '/dashboard/other/reports',
  },
  projectedWaterUsage: {
    path: '/other/projectedWaterUsage',
    to: '/dashboard/other/projectedWaterUsage',
  },
  waterUsage: {
    path: 'other/waterUsage',
    to: '/dashboard/other/waterUsage',
  },
  flowLog: {
    path: 'other/flowLog',
    to: '/dashboard/other/flowLog',
  },
  flowLogReport: {
    path: 'other/flowLogReport',
    to: '/dashboard/other/flowLogReport',
  },
  monthlyReportCard: {
    path: 'other/monthlyReportCard',
    to: '/dashboard/other/monthlyReportCard',
  },
  stationRunTime: {
    path: 'other/stationRunTime',
    to: '/dashboard/other/stationRunTime',
  },
  userManagement: {
    path: 'user-management',
    to: '/dashboard/user-management',
  },

  chartZeus: {
    path: 'chart-zeus',
    to: '/dashboard/chart-zeus',
  },
  diagnostics: {
    path: 'diagnostics',
    to: '/dashboard/diagnostics',
  },
}
